import React from 'react';
import './puclic/scss/style.css';  
import Baner from "./pageChild/Baner";
import Products from "./pageChild/Products";
import ProductsSale from "./pageChild/ProductsSale";
// import ApiProducts from "./pageChild/ApiProducts";
import BodyNow from "./pageChild/BodyNow";
import Outsoure from "./pageChild/Outsoure";
import Footer from "./pageChild/Footer";
import End from "./pageChild/End";
import OwlCarousels from "./pageChild/OwlCarousels";
import Intagram from "./pageChild/Intagram";
import NavBar from "./pageChild/NavBar";
import callApi from './../utils/apicaler';
import MessengerCustomerChat from 'react-messenger-customer-chat';
 

import { 
  Link
} from "react-router-dom";

 
class PageHome extends React.Component{
    constructor(props){
            super(props);
            this.state = {
                loader:"",
                cartId:0,
                products:[],
                redirct:0,

        	}
    }

    componentDidMount(){
        sessionStorage.setItem("title", "Tiệm Tạp Hóa MiêuMiêu - chuyên các đồ dùng theo trend");
        this.sestionCart()
        this.fucApi()
    }

    
    fucApi=()=>{
        callApi("", 'GET', null).then(res =>{
            this.setState({
                redirct:res.status
            })
        })
    }

    sestionCart = () =>{
        var cart = JSON.parse(sessionStorage.getItem('products'));
        if(cart === null){
        }else{
            cart.map((carts, index)=>{
                this.setState({cartId: index + 1})
            })
        }
    } 

   
    render(){
        const {loader, cartId, display, products, redirct} = this.state;
        var title = sessionStorage.getItem('title');
        var wapper = <div style={{background:"rgb(231, 239, 247)"}} className={`container-fluid custom_fluid` }>
                        <title>{title}</title>
                        <div className="row custom_row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                                <NavBar cartId={cartId}/>
                                <Baner />
              
                                <ProductsSale/>
                                <Products/>
                                <br/>
                                <OwlCarousels />
                                <Outsoure />
                                <div>
                                    <MessengerCustomerChat
                                        pageId="110404157244910"
                                        appId="313201206487594"
                                      />
                                </div> 
                                <Intagram />
                                <Footer />
                                <End /> 
                            </div>
                        </div>
                    </div>
    	return( 
            <div>
                { redirct === 200 ? wapper : <div className="loader loader-black loader-1"></div>}
            </div>
    	)
    }
}
 
export default PageHome;